import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import type { YearRange } from '../../domain/listings';

export interface GenerationFilter {
  generation: string;
  label: string;
  /** Production years from the generation's engine specs; null until they load (or if unknown). */
  years: YearRange | null;
}

function yearsLabel(years: YearRange | null): string {
  return years ? ` · ${years.from}-${years.to ?? 'now'}` : '';
}

interface GenerationPickerProps {
  filters: GenerationFilter[];
  selected: string[];
  onToggle: (generation: string) => void;
  onClear: () => void;
}

/** Picks which generations the page is about: the prices, the chart and the ads all follow it. */
export function GenerationPicker({ filters, selected, onToggle, onClear }: GenerationPickerProps) {
  if (filters.length < 2) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} sx={{ mb: 3, flexWrap: 'wrap', rowGap: 1 }} alignItems="center">
      <Typography variant="body2" color="text.secondary" sx={{ mr: 0.5 }}>
        Generations:
      </Typography>
      <Chip label="All" color={selected.length === 0 ? 'secondary' : 'default'} onClick={onClear} />
      {filters.map(({ generation, label, years }) => (
        <Chip
          key={generation}
          label={`${label}${yearsLabel(years)}`}
          color={selected.includes(generation) ? 'secondary' : 'default'}
          variant={selected.includes(generation) ? 'filled' : 'outlined'}
          onClick={() => onToggle(generation)}
        />
      ))}
    </Stack>
  );
}
